// extracted by mini-css-extract-plugin
module.exports = {"show":"magic-component-flash_show__PXlLx","flash-item":"magic-component-flash_flash-item__2UZej","notShow":"magic-component-flash_notShow__2-tEt"};